<div
  *ngFor="let appointment of appointments |
  orderArrayBy:'startDate.timestamp':'asc'"
  tabindex="0"
  class="date cursor-pointer"
  [ngClass]="{'shepherd-appointment-demo': appointment.metadata?.demo}"
  [class.selected]="(this.appointmentSelected$ | async)?._id ===
  appointment?._id"
  (click)="onEmitSelected(appointment)"
  nz-row>
  <!-- Decorador lateral izquierda -->
  <div nz-col class="bar-decorator">
    <div class="point">
    </div>
    <div class="bar mt-xxs"></div>
  </div>

  <!-- Evento y hora --> <!--container border-radius-lg-->
  <div nz-col nzFlex="1" class="container border-radius-lg">
    <div nz-row *ngIf="(appointment?.startDate.date | convertStringDate) as
      startDate">
      <div nz-col nzSpan="15" class="event text-subtitle-bold">{{appointment?.type
        | getTypeAppointment}}</div>
      <div nz-col nzSpan="9" class="hour text-subtitle-bold">
        {{ startDate | date:'hh:mm a' }}
        {{' (' + appointment?.minutes + ' min)'}}
      </div>
    </div>
    <!-- Imagenes y nombres de participantes -->
    <div nz-row class="mt-xs" nzAlign="middle">
      <nz-avatar-group nz-col [nzSpan]="appointment?.users.length> 1 ? 24 : 3"
        *ngIf="userLogged && userLogged?.experts">
        <app-avatar-user *ngFor="let user of appointment?.users; let i= index;"
          [image]="user.profileImageURL" [name]="user.name"
          [lastname]="user.lastname" [width]="27" [fontSize]="'12px'">
        </app-avatar-user>
      </nz-avatar-group>
      <app-concat-properties [ngStyle]="{'color': (this.appointmentSelected$ |
        async)?._id === appointment?._id ? 'white': 'black'}" *ngIf="userLogged
        && userLogged?.experts" [data]="appointment?.users"
        subfixSingular="participante más" subfixPlural="participantes más"></app-concat-properties>
      <!--cuando el usuario es apciente debe ver la imagen del experto-->
      <app-avatar-user *ngIf="appointment.expert && userLogged &&
        userLogged.patients"
        [image]="appointment?.expert?.user.profileImageURL"
        [name]="appointment?.expert?.user.name"
        [lastname]="appointment?.expert?.user.lastname" [width]="27"
        [fontSize]="'12px'" class="mr-xs"></app-avatar-user>
      <div class="text-regular-black opacity-50 truncate name"
        nz-col [nzSpan]="appointment?.users.length> 1 ? 24 : 21"
        [ngClass]="appointment?.users.length > 1 ? 'mt-xs' : ''"
        >
        <app-concat-properties *ngIf="appointment.expert && userLogged &&
          userLogged.patients" [data]="[appointment.expert.user]"
          subfixSingular="participante más" subfixPlural="participantes más"></app-concat-properties>
      </div>
    </div>
  </div>
</div>
